import { useLayoutEffect } from "react";
import { syncLoaderAnimation } from "../../utils/syncLoaderAnimation";

// Shown while a page's code is still downloading: the same loading mascot that
// public/index.html paints before any JS loads (styles live there too), so the
// first visit goes loader -> page with no blank frame in between.
const RouteFallback = () => {
  useLayoutEffect(syncLoaderAnimation, []);

  return (
    <div className="boot-splash">
      <div className="container">
        <div className="logo-container">
          <div className="logo">
            <img src={`${process.env.PUBLIC_URL}/boot-logo.png`} alt="Commenter AI" />
          </div>
        </div>
        <div className="loading-letters" aria-hidden="true">
          {"Loading...".split("").map((letter, i) => (
            <span key={i}>{letter}</span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RouteFallback;
